
import AppLayout from '../../components/feature/AppLayout';
import InteractionsSection from '../home/components/InteractionsSection';

export default function InteracoesPage() {
  return (
    <AppLayout>
      <InteractionsSection />
    </AppLayout>
  );
}
